
import React, { useState, useEffect } from 'react';
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import './PatientDashboard.css';
import { fetchDonorChartData, fetchPieChartData } from '../reduxactions/patientactions/PatientDashboardActions';
import { RootState } from '../reducers';
import { Panel } from 'primereact/panel';
import { Chart } from 'primereact/chart';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API, PATIENT_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import dataTablesAutoFill from '../assets/plugins/datatables-autofill/js/dataTables.autoFill';



const PatientDashboard: React.FC = () => {

  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')

  const dispatch = useDispatch();


  const [doctorCount, setDoctorCount] = useState<number | null>(null);
  const [userData, setUserData] = useState<[]>([]);

  const getdash = async () => {
    try {
      const payload = { userid: uid, q: 1 };
      const apiname = PATIENT_API.patientdashboard_API;
      const data = await LoginService.getData(apiname, payload);
      setUserData(data);
    } catch (error) {

    }
  };
  const [user, setUser] = useState<[]>([]);


  const getdash1 = async () => {
    try {
      const payload1 = { userid: uid, q: 2 };
      const apiname = PATIENT_API.patientdashboard_API;
      const data1 = await LoginService.getData(apiname, payload1);
      setUser(data1);
    } catch (error) {

    }
  };
  const [user1, setUser1] = useState<[]>([]);

  const getdash2 = async () => {
    try {
      const payload = { userid: uid, q: 3 };
      const apiname = PATIENT_API.patientdashboard_API;
      const data2 = await LoginService.getData(apiname, payload);
      setUser1(data2);
    } catch (error) {

    }
  };
  const [user2, setUser2] = useState<[]>([]);

  const getdash3 = async () => {
    try {
      const payload = { userid: uid, q: 4 };
      const apiname = PATIENT_API.patientdashboard_API;
      const data3 = await LoginService.getData(apiname, payload);
      setUser2(data3);

    } catch (error) {

    }
  };





  useEffectOnce(() => {
    getdash();
    getdash2();
    getdash3();
    getdash1();

  }, []);

  useEffectOnce(() => {
    const fetchDataAsync = async () => {
      try {
        await dispatch(fetchPieChartData(uid) as any);
        await dispatch(fetchDonorChartData(uid) as any);



      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchDataAsync();
  }, [dispatch]);
  const piechartData = useSelector((state: RootState) => state.patientdashboard.pieChartData);
  const ManagerchartData = useSelector((state: RootState) => state.patientdashboard.donorChartData);
  const piechartOptions = useSelector((state: RootState) => state.patientdashboard.piechartOptions);
  const ManagerchartOptions = useSelector((state: RootState) => state.patientdashboard.donorChart);

//for help
 const [openHelp, setHelp] = useState(false);
 const url1 = window.sessionStorage.getItem("apiRoot");
 const IUrl = `${url1}/help/patientdashboard.php`;
 const helpImg = `${url1}/help/help3.png`;
 const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
   event.preventDefault();
   const newWindowReference = window.open(
     targetUrl,
     'newwindow',
     'width=1000,height=1000,noopener,noreferrer'
   );
 
   if (newWindowReference) {
       newWindowReference.opener = null;
   }
 };

  return (
    <div className="grid">
      <div className="main-content">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="grid mb-2">
                <div className="col-9">
                  <h1>Dashboard</h1>
                </div>
                 <div className="col-3">
                <a
                  title="help"
                 onClick={(e) => openWindow(e, IUrl)}
                  style={{
                   
                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                <i style={{marginTop: 40,backgroundColor: "orange",color:"white" }} className = "pi pi-question-circle"></i>
                 
                </a>
              </div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="grid">
              <div className="col-3">
                <div>
                  <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-blue-400">
                    <div className="flex justify-content-between mb-3">
                      <div>
                        <span className="block text-500 font-medium mb-3 text-900">All Cases</span>
                        <div className="text-900 font-medium text-xl">
                          {userData}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-green-500 ">
                  <div className="flex justify-content-between mb-3">
                    <div>
                      <span className="block text-500 font-medium mb-3 text-900">Open Cases</span>
                      <div className="text-900 font-medium text-xl">{user}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-yellow-400">
                  <div className="flex justify-content-between mb-3">
                    <div>
                      <span className="block text-500 font-medium mb-3 text-900">Closed Cases</span>
                      <div className="text-900 font-medium text-xl">{user1}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-3">
                <div className="surface-0 shadow-2 p-3 border-1 border-50 border-round bg-red-500">
                  <div className="flex justify-content-between mb-3">
                    <div>
                      <span className="block text-500 font-medium mb-3 text-900">Family</span>
                      <div className="text-900 font-medium text-xl">{user2}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="grid">
              <section className="col-6">
                <div className="box box-danger">
                  <Panel header="Payment Details" toggleable>
                    <div style={{ width: '100%', height: '450px' }}>
                      <Chart
                        type="bar"
                        data={ManagerchartData}
                        options={ManagerchartOptions}
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div>
                  </Panel>

                </div>
              </section>
              <section className="col-6">
                <div className="box box-danger">
                  <Panel header="Cases" toggleable>
                    <Chart type="pie" style={{ height: '450px' }} data={piechartData} options={piechartOptions} />
                  </Panel>
                </div>
              </section>
            </div>

          </section>
        </div>
      </div>
    </div>
    //  </div>
  )
}
export default PatientDashboard;




